import { Hero } from "@/components/sections/Hero";
import { Welcome } from "@/components/sections/Welcome";
import { Experience } from "@/components/sections/Experience";
import { DressAttire } from "@/components/sections/DressAttire";
import { FoodMenu, CocktailMenu } from "@/components/sections/Menus";
import { VinylRitual } from "@/components/sections/VinylRitual";
import { RSVP } from "@/components/sections/RSVP";
import { Footer } from "@/components/sections/Footer";
import { StickyReserve } from "@/components/StickyReserve";
import { TopNav } from "@/components/TopNav";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-[#0a0a0a] text-[#FDFBF7]">
      <TopNav />
      <Hero />
      <Welcome />
      <Experience />
      <DressAttire />
      <FoodMenu />
      <CocktailMenu />
      <VinylRitual />
      <RSVP />
      <Footer />
      <StickyReserve />
    </main>
  );
}
